module.exports = __webpack_public_path__ + "img/lamp-1x.fe8c7a97.png";